<template>
  <div class="staff-nominations-overview">
    <div class="staff-nominations-overview__inner">
      <div class="staff-nominations-overview__table">
        <TableHeader :title="'Nominations'" :collection="nominations" />
        <LoadSpinner v-if="refreshing" style="padding: 2rem 0" />
        <div class="table-wrapper">
          <md-table>
            <md-table-row class="header-row">
              <md-table-head>
                Nominee Name
              </md-table-head>
              <md-table-head>Nominated By</md-table-head>
              <md-table-head>
                Nomination Status
              </md-table-head>
              <md-table-head>
                Nominee Email
              </md-table-head>
              <md-table-head>
                Nomination ID
              </md-table-head>
              <md-table-head>
                Nominator Organization
              </md-table-head>
              <md-table-head> Date Nominated </md-table-head>
            </md-table-row>

            <md-table-row
              class="body-row"
              v-for="nomination in nominations.list"
              :key="nomination.id"
              @click.native="() => {}"
            >
              <md-table-cell>{{
                nomination.full_name
              }}</md-table-cell>
              <md-table-cell>{{
                nomination.nominated_by
              }}</md-table-cell>
              <md-table-cell>{{
                nomination.status
              }}</md-table-cell>

              <md-table-cell>{{
                nomination.email
              }}</md-table-cell>
              <md-table-cell>{{
                nomination.id
              }}</md-table-cell>
              <md-table-cell>{{
                nomination.nominator_sub_organization
              }}</md-table-cell>
              <md-table-cell>{{
                nomination.date
              }}</md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import { LoadSpinner, TableHeader } from '@/components'

import NominationsApi from '@/services/nominations'
import Pagination from '@/services/pagination'

export default {
  name: 'NominationsOverview',
  components: {
    LoadSpinner,
    TableHeader,
  },
  data() {
    return {
      loading: true,
      nominations: {},
      refreshing: true,
      sorts: {
        user__last_name: null,
        user__organization__name: null,
        user__sub_organization__name: null,
        submitted_on: null,
        referred_on: null,
        _status: null,
        last_active: null,
        follow_up_date: null,
      },
      filters: {
        ordering: '-datetime_created',
        reportableEventCategories: [],
        statuses: [],
        organizations: [],
        referredOnly: null,
        nonReferredOnly: false,
        submittedStatuses: [],
        assignedTo: '',
        subOrganizations: [],
      },
    }
  },
  async mounted() {
    this.nominations.list = await NominationsApi.list() || []
    this.nominations.pagination = null
    this.nominations.refreshing = true
    this.loading = false
    this.refreshing = false
    this.nominations.refreshing = false
  },
  methods: {
    hasArrayFilter(filterKey) {
      let container = this.stipend_requests.filters[filterKey]
      return container ? container.length > 0 : false
    },
    clearArrayFilter(filterKey) {
      this.stipend_requests.filters[filterKey] = []
    },
  },
  computed: {
    ...mapState(['user', 'organizationDetails', 'organizationCssVars']),
  },
}
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/mixins/containers';

.staff-nominations-overview {
  @include screen-container($mobile-padding: 1rem 0.5rem, $desktop-max-width: 112rem);

  &__inner {
    max-width: 100%;
  }

  @media (min-width: $mobile-break-point) {
    &__inner {
      display: flex;
    }

    &__filters {
      flex: 1;
      padding: 1rem 2rem 0 1rem;
      min-width: 16rem;
    }

    &__table {
      flex: 8;
      overflow-x: auto;
    }
  }
}

// Table Styles
.header-row {
  background-color: $soft-gray;

  & > .md-table-head {
    font-size: 0.9rem;
  }
}

.body-row {
  & > .md-table-cell {
    border-top: 1px solid $soft-gray;
    padding: 0.5rem;
  }

  &:hover {
    background-color: $off-white;
    cursor: pointer;
  }
}

.warning-icon {
  color: $ruby;
}

.gray-row {
  background-color: $mid-gray;

  &:hover {
    background-color: $gray;
  }
}

.updated-icons {
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}

.icon-container {
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    background-color: $off-white;
    cursor: pointer;
  }
}

// Filter UI

.FilterAspect {
  margin-bottom: 32px;
}

.FilterAspect__Title {
  margin-bottom: 0;
}

.FilterAspect__Clear {
  color: gray;
}
</style>
